"use strict";

export let HoverEffect = /*#__PURE__*/function (HoverEffect) {
  HoverEffect[HoverEffect["NONE"] = 0] = "NONE";
  HoverEffect[HoverEffect["LIFT"] = 1] = "LIFT";
  HoverEffect[HoverEffect["HIGHLIGHT"] = 2] = "HIGHLIGHT";
  return HoverEffect;
}({});
//# sourceMappingURL=HoverEffect.js.map